function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.78847 14.4V5.44C9.18795 5.28 9.58742 5.04 9.82711 4.72L12.6234 5.76L10.3065 11.2C9.907 12.8 11.1054 13.6 13.1028 13.6C15.1002 13.6 16.3785 12.8 15.8991 11.2L13.8219 6.16L14.5409 6.4L15.1002 4.88L10.3864 3.2C10.3864 2.24 9.82711 1.28 8.78847 0.88C7.82973 0.48 6.79109 0.88 6.15193 1.6L1.51801 0L0.958742 1.44L2.23707 1.92L0.0798951 7.2C-0.319581 8.8 0.878847 9.6 2.87623 9.6C4.87361 9.6 6.15193 8.8 5.67256 7.2L3.67518 2.48L5.59266 3.2C5.59266 4.16 6.15193 5.12 7.19057 5.52V14.4H0V16H15.979V14.4H8.78847ZM14.3012 11.2H11.9044L13.1028 8.16L14.3012 11.2ZM4.07465 7.2H1.6778L2.87623 4.16L4.07465 7.2ZM7.27046 2.96C7.43025 2.56 7.90962 2.32 8.3091 2.48C8.70857 2.64 8.94826 3.12 8.78847 3.52C8.62868 3.92 8.14931 4.16 7.74983 4C7.35036 3.84 7.11067 3.36 7.27046 2.96Z",
  fill: "currentColor"
});

function SvgTod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTod);
export default __webpack_public_path__ + "static/media/tod.cadcfab7.svg";
export { ForwardRef as ReactComponent };